import { OrderListItem } from 'app/src/features/UserAccount/components/OrderListItem'
import type { GenericOrderItem } from 'app/src/model'
import { shoppingApi, type StatusConfigType } from 'app/src/services/welfareportal'
import { getFromSessionStorage } from 'app/src/shared/helpers'
import { NavigatePaths, useTranslation, useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { type ReactElement } from 'react'
import { useLocation } from 'react-router-dom'

export function UserAccountPrizeListSection(props: { directStatusList: StatusConfigType[] }): ReactElement {
  const { t } = useTranslation('userAccount', { keyPrefix: 'Prize' })
  const selectedCampaing = getFromSessionStorage('selectedCampaign') ?? '{}'
  const membershipId = JSON.parse(selectedCampaing).membershipId
  const { pathname } = useLocation()
  const { data, isLoading } = shoppingApi.useOrderList(
    {
      queryParams: { additionalInfoPrize: true, status: ['confirmed', 'used'], membershipId },
    },
    {
      enabled: pathname === NavigatePaths.UserAccount,
    },
  )
  const navigate = useWelfarePortalNavigate()

  return isLoading ? (
    <></>
  ) : data && data.items.length > 0 ? (
    <Card className='m-0 bg-[var(--card-background)] p-0' pt={{ body: { className: 'py-1' } }}>
      <div className='mb-2'>
        <div className='h-[31.5px] text-[21px] font-bold'>{t('Title')}</div>
      </div>
      <div>
        {data?.items &&
          data?.items.map((item, i) => {
            const genericItem: GenericOrderItem = {
              orderDate: item.orderDate,
              productTypology: item.productTypology,
              price: item.priceDetails?.grossPrice,
              priceLabel: t('PriceLabel'),
              seeDetailsLabel: t('SeeDetailsLabel'),
              productName: item.productName!,
              status: props.directStatusList.find((i) => i.key == item.status)?.label ?? 'N/A',
              detailsLink: item.detailPageUrl,
            }
            return <OrderListItem key={i} item={genericItem}></OrderListItem>
          })}
      </div>
    </Card>
  ) : (
    <Card className='m-0 bg-[var(--card-background)] p-0' pt={{ body: { className: 'py-1' } }}>
      <div className='mb-2'>
        <div className='h-[31.5px] text-[21px] font-bold'>{t('Title')}</div>
      </div>
      <div>{t('ClaimPrizeMsg')}</div>
      <Button
        className='mt-4'
        rounded
        label={t('ClaimPrizeLabel')}
        onClick={() => navigate.goToShowcase({ macroCategoryId: 'PRIZE' })}
      />
    </Card>
  )
}
